import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import ReCAPTCHA from 'react-google-recaptcha';

function SignUpSeller() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('Le password non coincidono!');
      return;
    }

    if (!captchaToken) {
      setMessage('Completa il reCAPTCHA.');
      return;
    }

    try {
      const response = await API.post('/auth/signup-seller', { email, password, captchaToken });
      if (response.data.success) {
        const userId = response.data.userId;
        navigate('/sign-up-seller-await-confirmation', { state: { userId } });
      }
    } catch (error) {
      setMessage(error.response ? error.response.data.message : 'Errore di rete');
    }
  };

  return (
    <div className="signup-seller-page">
      <div className="signup-seller-container">
        {/* Header con icona */}
        <div className="signup-seller-header">
          <div className="signup-seller-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3h18v18H3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 9h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="6" cy="6" r="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="18" cy="6" r="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="signup-seller-title">Registrazione Venditore</h2>
          <p className="signup-seller-subtitle">Step 1: Crea il tuo account venditore</p>
        </div>

        <form onSubmit={handleSubmit} className="signup-seller-form">
          {/* Email */}
          <div className="signup-seller-form-group">
            <label className="signup-seller-form-label">Email</label>
            <div className="signup-seller-input-wrapper">
              <svg className="signup-seller-input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <input
                type="email"
                className="signup-seller-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="La tua email aziendale"
                required
              />
            </div>
          </div>

          {/* Password e Conferma Password in riga */}
          <div className="signup-seller-row">
            <div className="signup-seller-form-group">
              <label className="signup-seller-form-label">Password</label>
              <div className="signup-seller-input-wrapper">
                <svg className="signup-seller-input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="16" r="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <input
                  type="password"
                  className="signup-seller-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Crea una password"
                  required
                />
              </div>
            </div>
            <div className="signup-seller-form-group">
              <label className="signup-seller-form-label">Conferma Password</label>
              <div className="signup-seller-input-wrapper">
                <svg className="signup-seller-input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="16" r="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <input
                  type="password"
                  className="signup-seller-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Conferma la password"
                  required
                />
              </div>
            </div>
          </div>

          {/* RECAPTCHA */}
          <div className="signup-seller-captcha">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={(token) => setCaptchaToken(token)}
            />
          </div>

          <button type="submit" className="signup-seller-submit-btn">
            <span>Prosegui</span>
            <svg className="signup-seller-submit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="m12 5 7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </form>

        {message && (
          <div className="signup-seller-message">
            <svg className="signup-seller-message-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {message}
          </div>
        )}

        {/* Footer con informazioni */}
        <div className="signup-seller-footer">
          <p className="signup-seller-footer-text">Dopo la registrazione dovrai completare il profilo aziendale</p>
          <div className="signup-seller-steps">
            <div className="signup-seller-step">
              <div className="signup-seller-step-number">1</div>
              <span>Registrazione</span>
            </div>
            <div className="signup-seller-step-arrow">→</div>
            <div className="signup-seller-step">
              <div className="signup-seller-step-number">2</div>
              <span>Verifica</span>
            </div>
            <div className="signup-seller-step-arrow">→</div>
            <div className="signup-seller-step">
              <div className="signup-seller-step-number">3</div>
              <span>Completa il Profilo Aziendale</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpSeller;
